module.exports = "/images/vendor/desiigner-svg/svg/logos/cartadocente.svg?94752e30cc91ec8241073c40ff40598b";